<template>
  <div class="main tabs_main back_main">
    <div class="back_item">
      <el-button icon="el-icon-back" @click="$emit('update:recordShow', false)">返回</el-button>
    </div>
    <div class="main_info">
      <div
        class="main_info_item"
        v-for="item in recordInfoList"
        :key="item.id">
        <span>{{item.materialName}}</span>
        <span class="main_info_item--value">{{statisticInfo[item.materialValue]}}</span>
      </div>
    </div>
    <div class="main_header" style="margin-top: 0">
      <div class="header_item">
        <span class="header_label">考核结果：</span>
        <el-select v-model="examResult" clearable placeholder="请选择考核结果">
          <el-option
            v-for="item in resultData"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="header_item">
        <span class="header_label">班组：</span>
        <el-select v-model="groupId" clearable placeholder="请选择班组">
          <el-option
            v-for="item in groupData"
            :key="item.groupId"
            :label="item.groupName"
            :value="item.groupId">
          </el-option>
        </el-select>
      </div>
      <div class="header_item">
        <span class="header_label">考核时间：</span>
        <el-date-picker 
          v-model="timeDate" 
          type="daterange" 
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </div>
      <div class="header_item">
        <el-button icon="el-icon-search" @click="searchExamineRecordList(true)">查询</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="examineRecordList"
        height="100%">
        <el-table-column label="序号" width="60" align="center">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="examName" label="考核名称" width="180" align="center"></el-table-column>
        <el-table-column prop="realName" label="姓名" align="center"></el-table-column>
        <el-table-column prop="groupName" label="班组" align="center"></el-table-column>
        <el-table-column prop="startTime" label="考核时间" align="center"></el-table-column>
        <el-table-column prop="useTime" label="用时" align="center"></el-table-column>
        <el-table-column prop="score" label="考核成绩" align="center"></el-table-column>
        <el-table-column label="考核结果" align="center">
          <template #default="{ row }">
            <span>{{row.pass === 1 ? '合格' : row.pass === 0 ? '不合格' : ''}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { buttonPinia } from '../../../../pinia';
  export default {
    name: 'ExamineRecord',
    props: {
      examineId: String,
      recordShow: Boolean
    },
    data() {
      return {
        recordInfoList: [{
          id: 1,
          materialName: '应考人数',
          materialValue: 'planExamUser'
        },{
          id: 2,
          materialName: '实考人数',
          materialValue: 'totalExamUser'
        },{
          id: 3,
          materialName: '缺考人数',
          materialValue: 'noExamUser'
        },{
          id: 4,
          materialName: '合格人数',
          materialValue: 'passExamUser'
        },{
          id: 5,
          materialName: '不合格人数',
          materialValue: 'noPassExanUser'
        }], // 页头信息
        statisticInfo: {}, // 统计信息
        examResult: '',
        resultData: [{
          value: 0,
          label: '不合格'
        },{
          value: 1,
          label: '合格'
        }], // 考核结果
        departId: '',
        groupId: '',
        groupData: [],
        timeDate: '',
        loading: false,
        pageNum: 1,
        pageSize: 10,
        total: 0,
        examineRecordList: []
      }
    },
    mounted() {
      this.getExamRecordStatistical();
      this.getAllDepartmentData();
      this.searchExamineRecordList(true);
    },
    methods: {
      // 获取部门班组信息
      async getAllDepartmentData() {
        const { data } = await this.$api.Personnerl.GETDEPARTMENTDATA();
        const groupData = data.map(item => item.groups);
        this.groupData = groupData.flat(Infinity);
      },
      // 查询考核记录统计
      async getExamRecordStatistical() {
        const { data } = await this.$api.Safety.getExamRecordStatistical({
          examId: this.examineId
        })
        this.statisticInfo = data;
      },
      // 查询记录信息
      searchExamineRecordList(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        this.loading = true;
        this.examineRecordList = [];
        this.$api.Safety.searchSafetyCheckRecord({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          examId: this.examineId,
          examResult: this.examResult,
          departId: this.departId,
          groupId: this.groupId,
          startTime: this.timeDate ? this.timeDate[0] + ' 00:00:00' : '',
          endTime: this.timeDate ? this.timeDate[1] + ' 23:59:59' : ''
        }).then((res) => {
          if(res.success) {
            this.total = res.data.total;
            this.examineRecordList = res.data.list;
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        })
      },
      // 切换页码
      changePageNum(page) {
        this.pageNum = page;
        this.searchExamineRecordList();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchExamineRecordList();
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '@/style/layout-main.scss';

.back_main {
  background: none !important;
}

.back_item {
  display: flex;
  justify-content: flex-end;
}

.main_info {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 20px 10px 10px;

  .main_info_item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: calc(100% / 8);
    height: 80px;
    color: #FFFFFF;
    background: url('../../../../assets/stir_img.png')no-repeat;
    background-size: 100% 100%;

    &:first-child {
      margin-left: 0 !important;
    }

    &:nth-child(odd) {
      margin: 0 20px;
    }

    .main_info_item--value {
      padding-top: 2px;
      color: #18F6F8;
      font-size: 18px;
    }
  }
}
</style>